import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import {
  Autocomplete,
  createTheme,
  Divider,
  FormHelperText,
  Grid2,
  IconButton,
  TextField,
  ThemeProvider,
  Typography,
  useTheme,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@mui/material";
import * as Yup from "yup";
import { useState } from "react";
import {
  useGetPackagesQuery,
  useLazyGetPackagesQuery,
} from "store/slices/apis/packageSlice";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import DragAndDropUpload from "components/FileUploader/DragAndDropUpload";
import { FaRegFileLines } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { useEditKeySafetyMutation } from "store/slices/apis/keySafetySlice";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const Statuses = [
  { label: "Open", value: "open" },
  { label: "Close", value: "close" },
];

const escalationRequired = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

export default function EditSafety(props) {
  const {
    open,
    cancelIssue,
    openNotification,
    data,
    isViewIssueModal,
    refetch,
  } = props;
  const newtheme = useTheme();
  const { projectId } = useParams();
  const [files, setFiles] = useState([]);
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const { data: packages } = useGetPackagesQuery({ projectId: projectId });
  const { data: contractors } = useGetContractorQuery();
  const [getSubPackage1, { data: subPackageList1 }] = useLazyGetPackagesQuery();
  const [getSubPackage2, { data: subPackageList2 }] = useLazyGetPackagesQuery();

  const [editKeySafety, { isLoading }] = useEditKeySafetyMutation();

  const [formData, setFormData] = useState({
    consultant_constractor: data?.consultant_constractor,
    date: data?.date,
    labour_man_hours: data?.labour_man_hours,
    manhours_since_last_lta_lti: data?.manhours_since_last_lta_lti,
    near_miss_incident: data?.near_miss_incident,
    ltas_ltis: data?.ltas_ltis,
    fatalities: data?.fatalities,
    // status: data?.status,
  });

  useEffect(() => {
    getSubPackage1({ projectId: projectId, type: "subPackage1" });
    getSubPackage2({ projectId: projectId, type: "subPackage2" });
  }, [open]);

  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#696969",
            },
            "& .MuiFilledInput-root.Mui-disabled": {
              backgroundColor: "#fff",
              color: "inherit",
            },
            "& .MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#696969",
              opacity: "none",
            },
          },
        },
      },
    },
  });

  const handleClose = () => { };

  const validationSchema = Yup.object({
    // consultant_constractor: Yup.string().required(
    //   "Consultant Contractor is required"
    // ),
    date: Yup.date()
      .required("Date is required")
      .nullable()
      .typeError("Date must be a valid date"),
    labour_man_hours: Yup.number().required("Labour Man Hours is required"),
    manhours_since_last_lta_lti: Yup.number().required(
      "Manhours Since Last LTA LTI is required"
    ),
    near_miss_incident: Yup.number().required("Near Miss Incident is required"),
    ltas_ltis: Yup.number().required("LTAs LTIs is required"),
    fatalities: Yup.number().required("Fatalities is required"),
    // status: Yup.string().required("Status is required"),
  });

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      openNotification("File type must be image/*");
      return;
    }
    const newFiles = acceptedFiles.filter(
      (file) => !files.some((f) => f.name === file.name)
    );

    if (newFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleRemoveFile = (fileName) => {
    setFiles(files.filter((file) => file.name !== fileName));
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    let reqBody = {
      project: data?.project,
      consultant_constractor: values.consultant_constractor,
      date:
        values?.date && dayjs(values.date).isValid()
          ? dayjs(values.date).format("YYYY-MM-DD") + "T00:00:00.000Z"
          : null,
      labour_man_hours: values.labour_man_hours,
      manhours_since_last_lta_lti: values.manhours_since_last_lta_lti,
      near_miss_incident: values.near_miss_incident,
      ltas_ltis: values.ltas_ltis,
      fatalities: values.fatalities,
      // status: values.status,
      ProjectId: projectId,
      safety_id: data?.safety_id,
      workflowApprovalId: data?.workflowApprovalId,
      safety_number: data?.safety_number
    };

    try {
      const formData = new FormData();
      formData.append("safetyJson", JSON.stringify({ ...reqBody }));
      formData.append("file", files);
      const response = await editKeySafety({
        id: data?.safety_id,
        body: formData,
      }).unwrap();
      if (response?.status == "Success") {
        openNotification(
          response?.message || "Safety updated successfully",
          "success"
        );
        resetForm();
        // refetch();
        cancelIssue();
      } else {
        openNotification("Error in safety updation");
      }
    } catch (error) {
      console.log("errr", error);

      openNotification(error?.data?.message, "error");
    } finally {
      setSubmitting(false);
    }
  };

  const CustomCalendarIcon = (props) => (
    <CalendarIcon {...props} style={{ width: 26, height: 26, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
  );


  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            overflowY: "inherit",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "20px", color: "#696969" }}>
          {isViewIssueModal ? "View" : "Edit"} Safety
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancelIssue}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
          <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px", fill: "#808080" }} />
        </IconButton>
        <Divider sx={{ w: 1 }} />
        <DialogContent>
          <ThemeProvider theme={theme}>
            <Box sx={{ mt: 1 }}>
              <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setTouched,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          {isViewIssueModal
                            ? "Safety Details"
                            : "Enter Safety Details"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={contractors?.data}
                          getOptionLabel={(option) => option.name}
                          value={
                            contractors?.data.find(
                              (option) => option.name === values.consultant_constractor
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "consultant_constractor",
                              newValue ? newValue.name : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, contractor: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Consultant/Contractor"
                              name="consultant_constractor"
                              // error={touched.consultant_constractor && Boolean(errors.consultant_constractor)}
                              // helperText={touched.consultant_constractor && errors.consultant_constractor}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.consultant_constractor && errors?.consultant_constractor && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.consultant_constractor}`}</FormHelperText>
                        )}
                      </Grid>
                      {/* <Grid item xs={6}>
                        <TextField
                          label="Consultant Contractor"
                          name="consultant_constractor"
                          fullWidth
                          value={values?.consultant_constractor}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              consultant_constractor: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.consultant_constractor &&
                          errors?.consultant_constractor && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.consultant_constractor}`}</FormHelperText>
                          )}
                      </Grid> */}

                      <Grid item xs={12} md={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Date"
                            disabled={isViewIssueModal}
                            value={values?.date ? dayjs(values.date) : null}
                            format="DD-MM-YYYY"
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "date",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, date: true })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "24px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.date && errors?.date && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.date}`}</FormHelperText>
                          )}
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          type="number"
                          label="Labour Man Hours"
                          name="labour_man_hours"
                          fullWidth
                          value={values?.labour_man_hours}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, labour_man_hours: true })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                          sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                        {touched?.labour_man_hours &&
                          errors?.labour_man_hours && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.labour_man_hours}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          type="number"
                          label="Manhours Since Last LTA LTI"
                          name="manhours_since_last_lta_lti"
                          fullWidth
                          value={values?.manhours_since_last_lta_lti}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              manhours_since_last_lta_lti: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                          sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                        {touched?.manhours_since_last_lta_lti &&
                          errors?.manhours_since_last_lta_lti && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.manhours_since_last_lta_lti}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          type="number"
                          label="Near Miss Incident"
                          name="near_miss_incident"
                          fullWidth
                          value={values?.near_miss_incident}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              near_miss_incident: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                          sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                        {touched?.near_miss_incident &&
                          errors?.near_miss_incident && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.near_miss_incident}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          type="number"
                          label="LTAs LTIs"
                          name="ltas_ltis"
                          fullWidth
                          value={values?.ltas_ltis}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              ltas_ltis: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                          sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                        {touched?.ltas_ltis && errors?.ltas_ltis && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.ltas_ltis}`}</FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          type="number"
                          label="Fatalities"
                          name="fatalities"
                          fullWidth
                          value={values?.fatalities}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              fatalities: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                          sx={{
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                            {
                              display: "none",
                            },
                            "& input[type=number]": {
                              MozAppearance: "textfield",
                            },
                          }}
                        />
                        {touched?.fatalities && errors?.fatalities && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.fatalities}`}</FormHelperText>
                        )}
                      </Grid>

                      {/* <Grid item xs={6}>
                        <Autocomplete
                          options={Statuses}
                          disabled={isViewIssueModal}
                          getOptionLabel={(option) => option?.label}
                          value={
                            Statuses.find(
                              (option) => option.label === values?.status
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "status",
                              newValue ? newValue.label : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, status: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Status"
                              name="status"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.status && errors?.status && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.status}`}</FormHelperText>
                        )}
                      </Grid> */}

                      {/* <Grid2 size={12}>
                                                {issueDetail?.data?.files?.length > 0 &&
                                                    <>
                                                        <List dense={dense}>
                                                            {issueDetail?.data?.files?.map((file, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    sx={{ padding: 0 }}
                                                                    secondaryAction={
                                                                        <IconButton edge="end" aria-label="delete" role="link" onClick={() => handleRemoveFile(index)}>
                                                                            <RxCross2 />
                                                                        </IconButton>
                                                                    }
                                                                >
                                                                    <ListItemAvatar>
                                                                        <Avatar sx={{ background: 'none' }}>
                                                                            <FaRegFileLines fontSize="inherit" style={{ color: '#474747' }} />
                                                                        </Avatar>
                                                                    </ListItemAvatar>
                                                                    <ListItemText
                                                                        primary={
                                                                            <span
                                                                                style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                                                                onClick={() => {
                                                                                    window.open(`${API_END_POINT}${file?.name}`, "_blank");
                                                                                }}
                                                                            >
                                                                                {file?.name}
                                                                            </span>
                                                                        }
                                                                        secondary={secondary ? 'Secondary text' : null}
                                                                    />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </>
                                                }
                                            </Grid2> */}

                      <Grid item xs={12}>
                        {files.length > 0 && (
                          <>
                            <Typography
                              variant="h6"
                              gutterBottom
                              style={{
                                color: "#474747",
                                fontWeight: "400",
                                fontSize: "16px",
                              }}
                            >
                              Uploaded Files
                            </Typography>

                            <List dense>
                              {files.map((file, index) => (
                                <ListItem
                                  key={index}
                                  sx={{
                                    padding: 0,
                                  }}
                                  secondaryAction={
                                    <IconButton
                                      edge="end"
                                      aria-label="delete"
                                      onClick={() =>
                                        handleRemoveFile(file.name)
                                      }
                                    >
                                      <RxCross2 />
                                    </IconButton>
                                  }
                                >
                                  <ListItemAvatar>
                                    <Avatar sx={{ background: "none" }}>
                                      <FaRegFileLines
                                        fontSize="inherit"
                                        style={{ color: "#474747" }}
                                      />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText primary={`${file.name}`} />
                                </ListItem>
                              ))}
                            </List>
                          </>
                        )}
                      </Grid>
                      {!isViewIssueModal && (
                        <Grid item xs={12}>
                          <DragAndDropUpload
                            onDrop={handleDrop}
                            multi={true}
                            fileType="both"
                          />
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        {/* <Button
                          onClick={cancelIssue}
                          variant="outlined"
                          sx={{
                            color: `${newtheme?.customSettings?.themeColor}`,
                            border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                            padding: "6px 20px",
                            fontWeight: "500",
                            textTransform: "none",
                            float: "right",
                            fontSize: "16px",
                            marginBottom: "20px",
                          }}
                        >
                          Cancel
                        </Button> */}
                        {!isViewIssueModal && (
                          <Button
                            type="submit"
                            loading={isLoading}
                            variant="contained"
                            sx={{
                              marginRight: "20px",
                              backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                              color: "#FFF",
                              padding: "6px 20px",
                              fontWeight: "500",
                              textTransform: "none",
                              float: "right",
                              fontSize: "16px",
                            }}
                          >
                            Edit Safety
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Box>
          </ThemeProvider>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
